module.exports = __webpack_public_path__ + "img/moular3.ddb6292d.png";